var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 28.625H24.375V23.9375C24.373 22.1976 23.681 20.5296 22.4507 19.2993C21.2204 18.069 19.5524 17.377 17.8125 17.375H12.1875C10.4476 17.377 8.77958 18.069 7.5493 19.2993C6.31903 20.5296 5.62699 22.1976 5.625 23.9375V28.625ZM8.4375 8.9375C8.4375 10.2354 8.82238 11.5042 9.54348 12.5834C10.2646 13.6626 11.2895 14.5038 12.4886 15.0005C13.6878 15.4972 15.0073 15.6271 16.2803 15.3739C17.5533 15.1207 18.7226 14.4957 19.6404 13.5779C20.5582 12.6601 21.1832 11.4908 21.4364 10.2178C21.6896 8.94478 21.5597 7.62528 21.063 6.42614C20.5663 5.227 19.7251 4.20208 18.6459 3.48098C17.5667 2.75988 16.2979 2.375 15 2.375C13.2595 2.375 11.5903 3.0664 10.3596 4.29711C9.1289 5.52782 8.4375 7.19702 8.4375 8.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.3198aa8109a14089fff138b777e4ab6b.svg";
export { ForwardRef as ReactComponent };